/**
 * Environment configuration utilities
 * Handles environment-specific settings and validation
 */

// Environment validation
export const validateEnvironment = () => {
  const requiredVars = [
    'REACT_APP_ENV',
    'REACT_APP_DOMAIN',
    'REACT_APP_STRIPE_PAYMENT_URL',
    'REACT_APP_STRIPE_SUCCESS_URL',
    'REACT_APP_STRIPE_CANCEL_URL'
  ];

  const missing = requiredVars.filter(varName => !process.env[varName]);
  
  if (missing.length > 0) {
    console.error('Missing required environment variables:', missing);
    return false;
  }
  
  return true;
};

// Get current environment
export const getEnvironment = () => {
  return process.env.REACT_APP_ENV || 'development';
};

// Get domain for current environment
export const getDomain = () => {
  return process.env.REACT_APP_DOMAIN || 'localhost:3000';
};

// Get Stripe payment configuration
export const getStripeConfig = () => {
  const config = {
    paymentUrl: process.env.REACT_APP_STRIPE_PAYMENT_URL,
    successUrl: process.env.REACT_APP_STRIPE_SUCCESS_URL,
    cancelUrl: process.env.REACT_APP_STRIPE_CANCEL_URL,
    promoCode: process.env.REACT_APP_STRIPE_PROMO_CODE || ''
  };

  // Validate configuration
  if (!config.paymentUrl) {
    console.error('REACT_APP_STRIPE_PAYMENT_URL is not configured');
    return null;
  }

  return config;
};

// Build complete Stripe URL with parameters
export const buildStripeUrl = () => {
  const config = getStripeConfig();
  
  if (!config) {
    console.error('Stripe configuration is not valid');
    return null;
  }

  const successUrl = encodeURIComponent(config.successUrl);
  const cancelUrl = encodeURIComponent(config.cancelUrl);

  let url = `${config.paymentUrl}?success_url=${successUrl}&cancel_url=${cancelUrl}`;
  
  // Only append promo code parameter if one is configured
  if (config.promoCode) {
    const promotionalCode = encodeURIComponent(config.promoCode);
    url += `&prefilled_promo_code=${promotionalCode}`;
  }

  return url;
};

// Environment info for debugging
export const getEnvironmentInfo = () => {
  return {
    environment: getEnvironment(),
    domain: getDomain(),
    stripeConfigured: !!getStripeConfig(),
    nodeEnv: process.env.NODE_ENV
  };
};

// Log environment info (useful for debugging)
export const logEnvironmentInfo = () => {
  const info = getEnvironmentInfo();
  console.log('Environment Info:', info);
  
  if (!validateEnvironment()) {
    console.warn('Some environment variables are missing. Check your .env files.');
  }
};